import gsap from 'gsap';
import Sniffer from 'sniffer';
import router from '@/router/index';

import { app, webgl, slider } from '../../utils/store';

class Logo {
  constructor() {
    this.el = document.getElementById('a-logo');
    this.slider = document.getElementById('a-slider');
  }

  init() {
    this.el.addEventListener('click', this.scroll);
  }

  scroll = () => {
    if (app.animating === true) return;

    app.animating = true;

    app.scroll.disable();
    app.scroll.data.current = 0;

    gsap.ticker.add(this.render);
  }

  render = () => {
    this.y = Math.abs(app.scroll.data.last);

    if (this.y === 0) {
      this.animate();
      gsap.ticker.remove(this.render);
    }
  }

  animate = () => {
    this.article = document.querySelector('article');

    app.scroll.off();

    if (webgl.pause === true) {
      webgl.app.play();
      webgl.pause = false;
    }

    let offsetY;

    if (Sniffer.isPhone) {
      offsetY = window.innerHeight * 0.15;
    } else {
      offsetY = 0;
    }

    // contact
    if (document.URL.includes('contact') || document.URL.includes('contatti')) {
      slider.next = 1;
      slider.current = 0;
      slider.app.setSlide();

      gsap.set(this.slider, {
        y: -window.innerHeight,
      });

      this.slider.style.visibility = 'inherit';

      gsap.to(this.slider, {
        y: 0,
        duration: 2,
        ease: 'expo.inOut',
      });

      gsap.fromTo(webgl.app, {
        shadowOpacity: 0,
        offsetY: window.innerHeight,
      }, {
        offsetY,
        duration: 2.1,
        shadowOpacity: 1,
        ease: 'expo.inOut',
        onComplete: this.load,
      });

      gsap.to(this.article, {
        duration: 2,
        ease: 'expo.inOut',
        y: window.innerHeight,
      });

      // default
    } else if (document.URL.includes('team')) {
      slider.app.nextSlide();
    } else {
      slider.app.prevSlide();
    }
  }

  load = () => {
    router.push(`/${app.language}/`);
    app.animating = false;
    app.contact = false;
  }
}

export default Logo;
